import api from 'api/apiInstance';

export function adviceRoomCalendarEventsApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
